module.exports = __webpack_public_path__ + "img/ambassador-commission.6004e9af.svg";